var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{staticClass:"page-header"},[_c('router-link',{staticClass:"page-header__link",attrs:{"tag":"a","to":"/"},nativeOn:{"click":function($event){return _vm.setFinish($event)}}},[_c('picture',[_c('source',{attrs:{"media":"(min-width: 660px)","srcset":require("../../static/img/logo-desktop.svg")}}),_vm._v(" "),_c('img',{staticClass:"page-header__img",attrs:{"src":require("../../static/img/logo-mobile.svg"),"alt":"Aviasales"}})])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-76fa063e","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/PageHeader.vue
// module id = 32
// module chunks = 0